import {
  RAPID_RESPONSE_FILTER_DATERANGE,
  SET_VIEW_POWER_BI_DATA,
  SET_VIEW_POWER_BI_ALERTS,
  FILTER_NETWORK,
  TAB_INDEX,
  FILTER_DC,
  FILTER_PRODUCTS,
  LOCATION,
  FILTER_CUSTOMERS,
  FILTER_DATERANGE,
  APPLY_FILTER,
  SAVE_FILTER,
  DELETE_FILTER,
  SET_FILTER,
  SET_LOGIN,
  SET_ROLE,
  FILTER_PL3,
  FILTER_CL6,
  FILTER_DIVISION,
  FILTER_SAVEDNAMES,
  FILTER_NAMES,
  FILTER_PERIOD_TYPE,
  SET_VIEW_POWER_BI,
  SET_DEEPDRIVE_TAB,
  SET_ACTIVE_ROUTE,
  SET_FILTER_LIST,
  SET_FILTER_PL3,
  SET_FILTER_DIVISION,
  SET_FILTER_CUSTOMER,
  SET_FILTER_PRODUCTS,
  SET_ACCESS_DETAILS,
  TAB_NAME,
  SET_PAST_DUE_CHECK,
  SET_ACTIVE_FLAG,
  FAC_ID,
  FAC_TYPE,
  TEMPERATURE,
  LANE,
  TO_ZIP,
  FROM_ZIP,
  TO_STATE,
  FROM_STATE,
  SET_SCENARIO_FLAG,
  SET_SCENARIOS,
  SET_SELECTED_SCENARIOS,
  SET_RECOM_FLAG,
  SET_ACTIVE_SCENARIOS,
  SET_ACTIVE_EVENTS_COUNT,
  SET_GRAPH_OR_MAP_VIEW,
  CP_DATERANGE,
  DIP_DATERANGE,
  SHOW_ALERT_GRAPH,
  MODULE_TAB_INDEX,
  SET_UNIT_VALUE,
  SET_SELECTED_NETWORKS,
  SET_DETAILS_SWITCH,
  SET_DETENTION_DATERANGE,
  SET_INCLUDE_NPOOS,
  SET_POOS_RADIO_BUTTON,
  SET_IOFPB_RADIO_BUTTON,
  SET_INCOTERM,
  FGS_DATERANGE,
} from "./Types";

export const TabActions = (newName) => ({
  type: TAB_INDEX,
  payload: newName,
});
export const TabNameChange = (newName) => ({
  type: TAB_NAME,
  payload: newName,
});
export const NetworkFilterActions = (newValue) => ({
  type: FILTER_NETWORK,
  payload: newValue,
});
export const PeriodTypeFiltersActions = (newValue) => ({
  type: FILTER_PERIOD_TYPE,
  payload: newValue,
});

export const DCFilterActions = (newValue) => ({
  type: FILTER_DC,
  payload: newValue,
});
export const ProductsFilterActions = (newValue) => ({
  type: FILTER_PRODUCTS,
  payload: newValue,
});

export const CustomersFilterActions = (newValue) => ({
  type: FILTER_CUSTOMERS,
  payload: newValue,
});

export const Pl3FilterActions = (newValue) => ({
  type: FILTER_PL3,
  payload: newValue,
});

export const Cl6FilterActions = (newValue) => ({
  type: FILTER_CL6,
  payload: newValue,
});

export const DivisionFilterActions = (newValue) => ({
  type: FILTER_DIVISION,
  payload: newValue,
});
export const savedFilterNameFilterActions = (newValue) => ({
  type: FILTER_SAVEDNAMES,
  payload: newValue,
});
export const FilterNameActions = (newValue) => ({
  type: FILTER_NAMES,
  payload: newValue,
});

export const DateRangeFilterActions = (newValue) => ({
  type: FILTER_DATERANGE,
  payload: newValue,
});
export const ApplyFilterActions = (list) => ({
  type: APPLY_FILTER,
  payload: list,
});
export const SaveFilter = (filter) => ({
  type: SAVE_FILTER,
  payload: filter,
});
export const DeleteFilter = (filter) => ({
  type: DELETE_FILTER,
  payload: filter,
});
export const SetFilter = (filtersList) => ({
  type: SET_FILTER,
  payload: filtersList,
});
export const SetLogin = (value) => ({
  type: SET_LOGIN,
  payload: value,
});
export const SetRole = (value) => ({
  type: SET_ROLE,
  payload: value,
});

export const setViewPowerBi = (viewPowerBi) => ({
  type: SET_VIEW_POWER_BI,
  payload: viewPowerBi,
});

export const setViewPowerBiAlerts = (viewPowerBi) => ({
  type: SET_VIEW_POWER_BI_ALERTS,
  payload: viewPowerBi,
});
export const setPowerBiData = (viewPowerBi) => ({
  type: SET_VIEW_POWER_BI_DATA,
  payload: viewPowerBi,
});
export const setDeepDriveTab = (viewPowerBi) => ({
  type: SET_DEEPDRIVE_TAB,
  payload: viewPowerBi,
});

export const setActiveRoute = (route) => ({
  type: SET_ACTIVE_ROUTE,
  payload: route,
});

export const setFilterList = (list) => ({
  type: SET_FILTER_LIST,
  payload: list,
});

export const setDivisionList = (list) => ({
  type: SET_FILTER_DIVISION,
  payload: list,
});

export const setPL3List = (list) => ({
  type: SET_FILTER_PL3,
  payload: list,
});
export const setProductList = (list) => ({
  type: SET_FILTER_PRODUCTS,
  payload: list,
});

export const setCustomerList = (list) => ({
  type: SET_FILTER_CUSTOMER,
  payload: list,
});

export const setAccessDetails = (accessDetails) => ({
  type: SET_ACCESS_DETAILS,
  payload: accessDetails,
});

export const setPastDueSTOCheck = (accessDetails) => ({
  type: SET_PAST_DUE_CHECK,
  payload: accessDetails,
});

export const setActiveFlag = (flagValue) => ({
  type: SET_ACTIVE_FLAG,
  payload: flagValue,
});

export const setIncoTerm = (value) => ({
  type: SET_INCOTERM,
  payload: value,
});
export const setScenarios = (flagValue) => ({
  type: SET_SCENARIOS,
  payload: flagValue,
});

export const setSelectedScenariosRR = (data) => ({
  type: SET_SELECTED_SCENARIOS,
  payload: data,
});

export const setSelectedNetworksRR = (data) => ({
  type: SET_SELECTED_NETWORKS,
  payload: data,
});

export const setRecomFlag = (flagValue) => ({
  type: SET_RECOM_FLAG,
  payload: flagValue,
});

export const setActiveScenarios = (data) => ({
  type: SET_ACTIVE_SCENARIOS,
  payload: data,
});

export const setActiveEventsCount = (data) => ({
  type: SET_ACTIVE_EVENTS_COUNT,
  payload: data,
});

export const setGraphOrMapView = (data) => ({
  type: SET_GRAPH_OR_MAP_VIEW,
  payload: data,
});

export const setScenariosFlag = (scenarioValue) => ({
  type: SET_SCENARIO_FLAG,
  payload: scenarioValue,
});

export const fromStateFilterAction = (newValue) => ({
  type: FROM_STATE,
  payload: newValue,
});

export const toStateFilterAction = (newValue) => ({
  type: TO_STATE,
  payload: newValue,
});

export const fromZipFilterAction = (newValue) => ({
  type: FROM_ZIP,
  payload: newValue,
});
export const toZipFilterAction = (newValue) => ({
  type: TO_ZIP,
  payload: newValue,
});

export const laneFilterAction = (newValue) => ({
  type: LANE,
  payload: newValue,
});

export const TemperatureFilterAction = (newValue) => ({
  type: TEMPERATURE,
  payload: newValue,
});

export const FacIDFilterAction = (newValue) => ({
  type: FAC_ID,
  payload: newValue,
});

export const LocationAction = (newValue) => ({
  type: LOCATION,
  payload: newValue,
});

export const FacTypeFilterAction = (newValue) => ({
  type: FAC_TYPE,
  payload: newValue,
});

export const DateRangeFilterForRapidResponseActions = (newValue) => ({
  type: RAPID_RESPONSE_FILTER_DATERANGE,
  payload: newValue,
});

export const DateRangeFilterCPActions = (newValue) => ({
  type: CP_DATERANGE,
  payload: newValue,
});

export const DateRangeFilterDIPActions = (newValue) => ({
  type: DIP_DATERANGE,
  payload: newValue,
});

export const DateRangeFilterFGSAction = (newValue) => ({
  type: FGS_DATERANGE,
  payload: newValue,
});

export const DateRangeFilterDetentionActions = (newValue) => ({
  type: SET_DETENTION_DATERANGE,
  payload: newValue,
});

export const setShowAlertGraph = (newValue) => ({
  type: SHOW_ALERT_GRAPH,
  payload: newValue,
});

export const setModuleTabIndex = (newValue) => ({
  type: MODULE_TAB_INDEX,
  payload: newValue,
});

export const setUnitValue = (newValue) => ({
  type: SET_UNIT_VALUE,
  payload: newValue,
});

export const setDetailsSwitch = (newValue) => ({
  type: SET_DETAILS_SWITCH,
  payload: newValue,
});

export const setIncludeNPOOS = (newValue) => ({
  type: SET_INCLUDE_NPOOS,
  payload: newValue,
});

export const setPOOSRadioButton = (newValue) => ({
  type: SET_POOS_RADIO_BUTTON,
  payload: newValue,
});

export const setIOFPBRadioButton = (newValue) => ({
  type: SET_IOFPB_RADIO_BUTTON,
  payload: newValue,
});
